// extracted by mini-css-extract-plugin
module.exports =  {"item":"CrumblepathItem-NjGM__item","label":"CrumblepathItem-XRUr__label","index":"CrumblepathItem-yzvk__index"};